import { Skeleton } from "./ui/skeleton";

export function ProductCardSkeleton() {
  return (
    <div className="overflow-hidden border rounded-3xl group transition-all duration-300">
      <div className="relative aspect-square">
        <Skeleton className="w-full h-full" />
      </div>
      <div className="p-4">
        <div className="flex flex-wrap gap-1 mb-3">
          <Skeleton className="h-5 w-20" />
        </div>
        <Skeleton className="h-6 w-3/4 mb-2" />
        <Skeleton className="h-5 w-1/4" />
      </div>
      <div className="p-4 pt-0 flex gap-2">
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-10 w-full" />
      </div>
    </div>
  );
}